module.exports = __webpack_public_path__ + "images/universal-access_89a8293e21c292339f9b13361d342d5f.png";